import { useDefaultSortingItem } from 'src/hooks'
import { useLocales } from 'src/locales'

export const useTransferConfig = () => {
  const { t } = useLocales()

  const { defaultSortingOption } = useDefaultSortingItem()

  const options = [
    defaultSortingOption,
    {
      value: 'startDate',
      label: t('transfer.start_date_asc')
    },
    {
      value: '-startDate',
      label: t('transfer.start_date_desc')
    },
    {
      value: 'endDate',
      label: t('transfer.end_date_asc')
    },
    {
      value: '-endDate',
      label: t('transfer.end_date_desc')
    }
  ]

  return { options }
}
